var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-full-width',{attrs:{"title":_vm.$tc('profile', 1)}})}
var staticRenderFns = []

export { render, staticRenderFns }